export const lightTheme = {
    body: '#F5f7f7',
    text: '#363537',
    toggleBorder: '#FFF',
    background: '#FFF',
    a: '#000',
    a_hover: '#505251',
    background_image: 'imagens/bkg_white.jpg',
    background_maximize: 'imagens/icones/icon-expandir-black.png',
    /*background_image: 'imagens/bkg_black.jpg',*/
    toggler_icon: '0%',
    aesop_logo: '100%',
    fiocruz_logo: '100%',
    cor_diferenciada: '#3f7d61',
    texto_noticia: '#000',
    fundo_noticia: '#fff',
    fundo_navbar: '255, 255, 255, 1.00', //60
    legenda_graficos: '#fff',
    background_grafico: '#d0cfd3',
    noticia_home_bg: '#C5C5C5',
    lasted_news_bg: '#797979',
}

export const darkTheme = {
    body: '#000',
    text: '#fff',
    toggleBorder: '#6B8096',
    background: '#999',
    a : '#ffff',
    a_hover: '#D2d2d2',
    background_image: 'imagens/bkg_black.jpg',
    background_maximize: 'imagens/icones/icon-expandir-white.png',
    toggler_icon: '100%',
    aesop_logo: '0%',
    fiocruz_logo: '0%',
    cor_diferenciada: '#75ffc0',
    texto_noticia: '#fff',
    fundo_noticia: '#000',
    fundo_navbar: '0, 0, 0, 1.00', //40
    legenda_graficos: '#fff',
    background_grafico: '#222327',
    noticia_home_bg: '#2b2b2b',
    lasted_news_bg: '#000',
}